import { Injectable } from "@angular/core";
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelDataProvider {

  ExcelToJSON = function () {
    this.parseExcel = function (file: File): Promise<string> {
      var reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.readAsArrayBuffer(file);

        reader.onload = function (e: ProgressEvent<FileReader>) {
          var data = e.target!.result;
          var workbook = XLSX.read(data, { type: 'array' });
          workbook.SheetNames.forEach(function (sheetName: string) {
            var XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            var json_object = JSON.stringify(XL_row_object);
            resolve(json_object);
          });
        };

        reader.onerror = function (ex) {
          console.log(ex);
          reject(ex);
        };
      });
    };
  };
}
